import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';

import { Heading, Subtitle, SanityImage, Markdown } from '../elements';

const Section = styled.section`
  .button {
    justify-content: space-between;
  }

  .card:hover {
    background: ${(props) => props.theme.darkShades} !important;
    transition: background 0.7s ease;
  }
  .card:hover .is-hovered {
    color: ${(props) => props.theme.lightShades} !important;
  }
  .card {
    border: 3px solid ${(props) => props.theme.borderColor};
    min-height: 23rem;
  }
  .card {
    height: 100%;
  }
`;

const ContactInformation = ({ title }) => {
  const { sanityGlobals } = useStaticQuery(graphql`
    {
      sanityGlobals {
        contactBlock {
          _key
          title
          subtitle
          description
          href
          image {
            asset {
              gatsbyImageData
            }
          }
        }
      }
    }
  `);

  const data = sanityGlobals;
  return (
    <Section className="section is-medium">
      <div className="container">
        {title && (
          <div className="columns is-centered mb-5">
            <div className="column is-8 has-text-centered">
              <Markdown>{title}</Markdown>
            </div>
          </div>
        )}

        <div className="columns is-multiline">
          {data &&
            data.contactBlock.map((item) => {
              if (!item) return null;
              return (
                <a
                  target="_blank"
                  href={item.href ? item.href : '#'}
                  className="column is-4"
                  key={item._key}
                  rel="noreferrer"
                >
                  <div className="card is-borderless">
                    <div className="card-content p-6">
                      <div className="media-content has-text-centered">
                        {item.image && (
                          <figure className="image is-64x64 m-auto">
                            <SanityImage
                              gatsbyImageData={item.image.asset.gatsbyImageData}
                              alt="images"
                            />
                          </figure>
                        )}

                        <Heading
                          dark
                          className="is-6 is-size-7-mobile has-text-weight-bold is-hovered mt-5"
                        >
                          {item.title}
                        </Heading>
                        <Subtitle
                          dark
                          className="has-text-weight-bold subtitle is-6 is-size-7-mobile mt-3 is-hovered"
                        >
                          {item.subtitle}
                        </Subtitle>
                        <Subtitle
                          dark
                          className="subtitle is-6 tt-2 is-hovered"
                        >
                          {item.description}
                        </Subtitle>
                      </div>
                    </div>
                  </div>
                </a>
              );
            })}
        </div>
      </div>
    </Section>
  );
};

export default ContactInformation;
